import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useInvite } from '../../hooks/useInvite'
import styles from './styles.module.css'

export const InviteLinkComponent = () => {
  const { t } = useTranslation()
  const { invite, loading, generateNewInvite } = useInvite()
  const [copied, setCopied] = useState(false)

  const handleCopy = async () => {
    if (invite?.inviteUrl) {
      await navigator.clipboard.writeText(invite.inviteUrl)
      setCopied(true)
      setTimeout(() => setCopied(false), 2000)
    }
  }

  const handleGenerateNew = async () => {
    await generateNewInvite()
  }

  if (loading) {
    return <div className={styles.inviteLoading}>{t('invite_link.loading')}</div>
  }

  return (
    <div className={styles.inviteContainer}>
      <div className={styles.inviteHeader}>
        <h3>{t('invite_link.title')}</h3>
        <p>{t('invite_link.subtitle')}</p>
      </div>

      {invite?.inviteUrl ? (
        <div className={styles.inviteContent}>
          <div className={styles.inviteLinkBox}>
            <input
              type="text"
              value={invite.inviteUrl}
              readOnly
              className={styles.inviteInput}
            />
            <button onClick={handleCopy} className={styles.copyButton}>
              {copied ? t('invite_link.copied') : t('invite_link.copy')}
            </button>
          </div>

          <div className={styles.inviteStats}>
            <div className={styles.statItem}>
              <span className={styles.statNumber}>
                {invite.triggeredUsers?.length || 0}
              </span>
              <span className={styles.statLabel}>{t('invite_link.invited_friends')}</span>
            </div>
          </div>
        </div>
      ) : (
        <div className={styles.noInvite}>
          <p>{t('invite_link.no_invite')}</p>
          <button onClick={handleGenerateNew} className={styles.generateButton}>
            {t('invite_link.generate_invite')}
          </button>
        </div>
      )}
    </div>
  )
}
